import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/system-notification-user'

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}

export const update = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}`,
    data,
  })
  return response?.data
}

export const unread = async () => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/unread`,
  })
  return response?.data
}